export default {"src":"/_next/static/media/instagram-icon.9d44c75a.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};